// Serviço de Chatbot Inteligente Local
// Usa processamento de linguagem natural e base de conhecimento local    // Remova a função não utilizadaI_CONFIG } from '../config/aiConfig';

// Base de conhecimento expandida sobre Moçambique
const MOZAMBIQUE_KNOWLEDGE = {
  cultura: {
    "karingana": "Karingana é uma expressão tradicional moçambicana usada para iniciar contos e histórias, semelhante ao 'Era uma vez' em português. É uma palavra mágica que transporta os ouvintes para o mundo da imaginação.",
    "marrabenta": "Marrabenta é um género musical tradicional de Moçambique, especialmente popular em Maputo. Caracteriza-se por ritmos animados e letras que falam sobre a vida quotidiana e amor.",
    "timbila": "Timbila é um instrumento musical tradicional do povo Chopi, feito de madeira e cabaças. É reconhecido pela UNESCO como Património Cultural Imaterial da Humanidade.",
    "mapiko": "Mapiko é uma dança tradicional maconde, caracterizada por máscaras elaboradas e movimentos rítmicos que contam histórias ancestrais.",
    "makonde": "Os Makonde são um grupo étnico conhecido pela sua arte em madeira, especialmente esculturas que retratam a vida familiar e espiritual."
  },
  ecologia: {
    "gorongosa": "O Parque Nacional da Gorongosa é um dos ecossistemas mais biodiversos de África, com leões, elefantes, hipopótamos e mais de 500 espécies de aves.",
    "mangais": "Os mangais de Moçambique são florestas costeiras que protegem contra erosão, servem de viveiro para peixes e são essenciais para a biodiversidade marinha.",
    "zambeze": "O rio Zambeze é o maior de Moçambique, com 2574 km. É vital para agricultura, pesca, energia hidroelétrica e biodiversidade.",
    "biodiversidade": "Moçambique possui uma biodiversidade excecional com mais de 5000 espécies de plantas, 740 espécies de aves e 200 espécies de mamíferos.",
    "conservacao": "Moçambique tem vários parques nacionais e áreas protegidas que preservam a biodiversidade única do país."
  },
  geografia: {
    "provincias": "Moçambique tem 11 províncias: Maputo, Gaza, Inhambane, Sofala, Manica, Tete, Zambézia, Nampula, Cabo Delgado, Niassa e Maputo Cidade.",
    "clima": "Moçambique tem clima tropical com estação chuvosa de novembro a março e estação seca de abril a outubro.",
    "costa": "Moçambique tem 2470 km de costa no Oceano Índico, com praias paradisíacas e recifes de coral.",
    "montanhas": "As montanhas mais altas incluem o Monte Binga (2436m) na província de Manica e o Monte Namúli (2419m) na Zambézia."
  },
  lingua: {
    "changana": "Changana é uma língua bantu falada principalmente no sul de Moçambique, especialmente em Maputo e Gaza.",
    "macua": "Macua é a língua bantu mais falada em Moçambique, principalmente no norte do país.",
    "sena": "Sena é falada na região central, especialmente ao longo do rio Zambeze.",
    "ndau": "Ndau é falada na província de Sofala e partes de Manica.",
    "tsonga": "Tsonga é falada no sul, especialmente na província de Gaza."
  }
};

// Função para normalizar texto (remover acentos, converter para minúsculas)
const normalizarTexto = (texto) => {
  return texto
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove acentos
    .replace(/[^\w\s]/g, ' ') // Remove pontuação
    .replace(/\s+/g, ' ') // Remove espaços extras
    .trim();
};

// Função para calcular similaridade entre duas strings
const calcularSimilaridade = (str1, str2) => {
  const s1 = normalizarTexto(str1);
  const s2 = normalizarTexto(str2);
  
  if (s1 === s2) return 1.0;
  
  const words1 = s1.split(' ');
  const words2 = s2.split(' ');
  
  const intersection = words1.filter(word => words2.includes(word));
  const union = [...new Set([...words1, ...words2])];
  
  return intersection.length / union.length;
};

// Função para encontrar a melhor resposta baseada no conhecimento
const encontrarRespostaLocal = (pergunta) => {
  const perguntaNormalizada = normalizarTexto(pergunta);
  let melhorResposta = null;
  let melhorScore = 0;

  // Procurar em todas as categorias
  // Procurar nas palavras-chave e no conteúdo das respostas
  Object.values(MOZAMBIQUE_KNOWLEDGE).forEach(categoria => {
    Object.entries(categoria).forEach(([palavraChave, resposta]) => {
      // Procurar similaridade com a palavra-chave
      const scoreChave = calcularSimilaridade(perguntaNormalizada, palavraChave);
      // Procurar palavras da pergunta no conteúdo da resposta
      const scoreConteudo = calcularSimilaridade(perguntaNormalizada, resposta);
      
      const scoreFinal = Math.max(scoreChave, scoreConteudo);
      if (scoreFinal > melhorScore && scoreFinal > 0.2) { // Reduzido de 0.3 para 0.2
        melhorScore = scoreFinal;
        melhorResposta = resposta;
      }
    });
  });

  return { resposta: melhorResposta, score: melhorScore };
};

// Função para gerar resposta contextual
const gerarRespostaContextual = (pergunta) => {
  const perguntaNormalizada = normalizarTexto(pergunta);
  
  // Palavras-chave específicas
  const palavrasChave = {
    "o que é": "explicação",
    "como": "processo",
    "quando": "tempo",
    "onde": "localização",
    "quem": "pessoa",
    "por que": "razão",
    "qual": "identificação"
  };

  // Detectar tipo de pergunta
  let tipoPergunta = "geral";
  Object.entries(palavrasChave).forEach(([palavra, tipo]) => {
    if (perguntaNormalizada.includes(palavra)) {
      tipoPergunta = tipo;
    }
  });

  // Respostas baseadas no contexto
  const respostasContextuais = {
    "explicação": "Baseado no que sei sobre Moçambique, posso explicar que ",
    "processo": "Em Moçambique, o processo envolve ",
    "tempo": "Historicamente em Moçambique, ",
    "localização": "Em Moçambique, isso pode ser encontrado ",
    "pessoa": "Em Moçambique, as pessoas ",
    "razão": "A razão principal em Moçambique é ",
    "identificação": "Em Moçambique, identifica-se como ",
    "geral": "Sobre Moçambique, posso dizer que "
  };

  return respostasContextuais[tipoPergunta] || respostasContextuais.geral;
};

// Função principal do chatbot
export const processarPergunta = async (pergunta) => {
  try {
    // Usar apenas o sistema de resposta local
    const resultadoLocal = encontrarRespostaLocal(pergunta);
    const respostaMelhorada = melhorarResposta(resultadoLocal.resposta, pergunta);
    
    return {
      resposta: respostaMelhorada,
      fonte: resultadoLocal.resposta ? "base_local" : "contexto",
      confianca: resultadoLocal.score || 0.5
    };

    return {
      resposta: "Não tenho uma resposta específica para essa pergunta, mas posso falar sobre cultura, ecologia, geografia e línguas de Moçambique.",
      fonte: "fallback",
      confianca: 0.3
    };

  } catch (error) {
    console.error("Erro no processamento da pergunta:", error);
    const respostaMelhorada = melhorarResposta(null, pergunta);
    return {
      resposta: respostaMelhorada || "Desculpe, estou com dificuldades técnicas. Pode tentar perguntar sobre cultura moçambicana, ecologia, ou geografia do país.",
      fonte: respostaMelhorada ? "contexto" : "erro",
      confianca: respostaMelhorada ? 0.5 : 0.1
    };
  }
};

// Função para usar API gratuita do Hugging Face
// Funções de API removidas pois estamos usando apenas o sistema local

// Função para obter sugestões de perguntas
export const obterSugestoes = () => {
  const sugestoes = [
    "O que significa Karingana?",
    "Conte-me sobre a Marrabenta",
    "O que é o Parque da Gorongosa?",
    "Quais são as línguas de Moçambique?",
    "Como é o clima em Moçambique?",
    "O que são mangais?",
    "Conte-me sobre a Timbila",
    "Quais são as províncias de Moçambique?"
  ];
  
  return sugestoes;
};

// Função para melhorar a resposta com contexto moçambicano
export const melhorarResposta = (resposta, pergunta) => {
  const perguntaNormalizada = normalizarTexto(pergunta);
  
  // Se não houver resposta específica, tentar dar uma resposta contextual
  if (!resposta) {
    const palavrasChaveContexto = {
      'cultura': 'A cultura moçambicana é rica e diversa, incluindo expressões como Karingana, Marrabenta e Timbila.',
      'música': 'A música tradicional moçambicana inclui estilos como Marrabenta e Timbila.',
      'dança': 'Moçambique tem danças tradicionais importantes como o Mapiko.',
      'língua': 'Em Moçambique são faladas várias línguas como Changana, Macua, Sena e outras.',
      'animal': 'Moçambique tem uma fauna diversa, especialmente no Parque Nacional da Gorongosa.',
      'natureza': 'A natureza em Moçambique é rica, com mangais, o rio Zambeze e diversos ecossistemas.',
      'geografia': 'Moçambique tem 11 províncias e uma costa extensa no Oceano Índico.'
    };

    for (const [chave, respostaContextual] of Object.entries(palavrasChaveContexto)) {
      if (perguntaNormalizada.includes(chave)) {
        return respostaContextual;
      }
    }
  }

  // Se tiver resposta mas não mencionar Moçambique, adicionar contexto
  if (resposta && !resposta.toLowerCase().includes('moçambique') && 
      !resposta.toLowerCase().includes('mozambique')) {
    
    if (perguntaNormalizada.includes('cultura') || 
        perguntaNormalizada.includes('tradição') ||
        perguntaNormalizada.includes('música')) {
      return `Em Moçambique, ${resposta}`;
    }
    
    if (perguntaNormalizada.includes('natureza') || 
        perguntaNormalizada.includes('animal') ||
        perguntaNormalizada.includes('planta')) {
      return `${resposta} Esta é uma característica importante da biodiversidade moçambicana.`;
    }
  }
  
  return resposta || 'Posso ajudar com informações sobre a cultura, natureza, geografia e línguas de Moçambique. O que gostaria de saber?';
}; 